import { useQuestionLabel } from '../../../../../../../../hooks/useQuestionLabel';
import type { FieldType, ReportType, TextQuestion } from '../../../../../../../../shared/types';

type Result = ModelHookResult<{
	fieldName: string;
	questionLabel: string;
}>;

type Props = {
	type: ReportType;
	parent: FieldType;
	question: TextQuestion;
	idx: number;
};

export function useTextQuestionField({ type, parent, question, idx }: Props): Result {
	const {
		data: { questionLabel },
	} = useQuestionLabel(type, parent, question.name);
	// This is used by the form to know which property we're accessing
	const fieldName = `question${idx}`;
	return {
		data: {
			fieldName,
			questionLabel,
		},
	};
}
